import {defineStore} from "pinia";
import http from "../api/http";

export const useArticles = defineStore('articles', {
    state: () => ({
        articlesList: [],
        articlesDetail: []
    }),
    getters: {
        getArticlesList: (state) => state.articlesList,
        getArticlesDetail: (state) => state.articlesDetail,
    },
    actions: {
        articlesListApi() {
            http.articlesList().then(res => {
                this.articlesList = res.data
            })
        },
        articlesDetailApi(id) {
            http.articlesDetail({id}).then(res => {
                this.articlesDetail = res.data
            })
        }
    }
})
